import type { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { isTransparentBackground, WidgetBackground } from '@elfsight/widget-ui';
import { useLocationCardProps } from '../location-card-settings-context';

export function LayoutBackground({ children }: PropsWithChildren) {
  const {
    background,
    verticalPadding,
    horizontalPadding,
    renderThumbnailMode,
    fullHeight
  } = useLocationCardProps();

  /* В режиме создания скриншота фон не должен быть прозрачным */
  const shouldApplyWhiteBackground =
    !!renderThumbnailMode &&
    isTransparentBackground({
      type: background?.type,
      color: background?.color
    });
  if (shouldApplyWhiteBackground) {
    background.color = '#fff';
  }

  return (
    <StyledWidgetBackground
      _withShadow={!!renderThumbnailMode}
      _fullHeight={fullHeight}
      {...background}
      borderRadius={renderThumbnailMode ? 20 : background?.borderRadius}
      horizontalPadding={horizontalPadding}
      verticalPadding={verticalPadding}
    >
      {children}
    </StyledWidgetBackground>
  );
}

const StyledWidgetBackground = styled(WidgetBackground)<{
  _withShadow?: boolean;
  _fullHeight?: boolean;
}>`
  min-height: ${({ _fullHeight }) => (_fullHeight ? '100%' : 0)};
  overflow: hidden;
  ${({ _withShadow }) =>
    _withShadow &&
    css`
      box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.1);
    `}
`;
